import React, {useState, useEffect} from 'react';
import {
	Card, CardActionArea, FormControl,
	CardContent, MenuItem, Button,
	Tabs, Tab, Paper, Typography,
	Select, Checkbox, Stack, Box,
	Pagination
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Carousel from '../Carousel';
import EventCard from '../EventCard';
import Footer from '../Footer';
import { classes } from './HomeStyles';
import {
	DEFAULT_FILTERS, locations,
	eventTypeOptions, eventCategories
} from './constants';

const Home = () => {
	const[events, setEvents] = useState([]);
	const[futureEvents, setFutureEvents] = useState([]);
	const[totalEvents, setTotalEvents] = useState(0);
	const[totalPages, setTotalPages] = useState(0);
	const[tabValue, setTabValue] = useState(0);
	const[page, setPage] = useState(1);
	const[executionStatus, setExecutionStatus] = useState('upcoming');
	const[filterValues, setFilterValues] = useState(DEFAULT_FILTERS);
	const isMobile = useMediaQuery('(max-width:768px)');

	useEffect(() => {
		loadFutureEvents();
		loadEventsInfo(1)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const buildQueryParams = (filters) => {
		const params = new URLSearchParams();
		if (filters.category.length > 0) {
			params.append('search_custom_fields[903857]', filterValues.category.join(','));
		}
		if (filters.location.length > 0) {
			params.append('search_custom_fields[903858]', filterValues.location.join(','));
		}
		if (filters.type) params.append('search_custom_fields[903859]', filters.type);
		return params.toString();
	};

	let loadEventsInfo = (page) => {
		// eurobiomed uuid 7cd8b171-d0de-4485-9
		// `https://connect.eventtia.com/en/api/v2/7cd8b171-d0de-4485-9/events/list?page_size=12&page=${page}&show_in_widget=true&keywords=${keywords}&start_date=${start_date}&category_id=${category_id}&execution_status=${execution_status}&status=active&search_custom_fields%5B542305%5D=si`
		
		const execution_status = executionStatus;
		const baseURL = `https://connect.eventtia.com/en/api/v3/accounts/7cd8b171-d0de-4485-9/calendar?page[size]=12&page[number]=${page}&show_in_widget=true&execution_status=${execution_status}&status=active&order="start_date asc"`
		const queryFilters = buildQueryParams(filterValues, baseURL);
		const queryURL = queryFilters ? `${baseURL}&${queryFilters}`: baseURL;
		
		fetch(queryURL)
			.then(results => results.json())
			.then((data) => {
				const events = data.data || [];
				setEvents(events);
				setTotalEvents(data.meta.total_events);
				setTotalPages(data.meta.total_pages);
		});
	};

	useEffect(() => {
		if (filterValues === DEFAULT_FILTERS){
			setPage(1);
			loadEventsInfo(1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterValues]);

	let handlePageChange = (event, page) => {
		setPage(page);
		loadEventsInfo(page)
	}

	let searchEvents = () => {
		setPage(1);
		loadEventsInfo(1)
	}

	let clearFilters = () => {
		setFilterValues(DEFAULT_FILTERS);
		// setEventType(DEFAULT_FILTERS.event_type);
	}

	useEffect(() => {
		loadEventsInfo(1)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [executionStatus])

	let loadFutureEvents = () => {
		fetch(`https://connect.eventtia.com/en/api/v3/accounts/7cd8b171-d0de-4485-9/calendar?page[size]=3&show_in_widget=true&execution_status=upcoming&featured=true&status=active&order="start_date asc"`)
		.then(results => results.json())
		.then((data) => {
			setFutureEvents(data.data)
		})
	}

	const handleChangeTab = (event, newValue) => {
		setTabValue(newValue)
		switch(newValue) {
			case 0:
				return setExecutionStatus('upcoming');
			case 1:
				return setExecutionStatus('all');
			case 2:
				return setExecutionStatus('past');
			case 3:
				return setExecutionStatus('current');
			default:
				return setExecutionStatus('current');
		}
	}

	let cardEventsListHeader = () => {
		return(
			<Box sx={classes.header}>
				<Stack
					direction="row"
					justifyContent={"space-between"}
				>
					<Typography sx={classes.title}>Evénements à venir</Typography>
					<Box
						sx={classes.clearFilters}
						onClick={() => {
							clearFilters();
						}}
					>
						Effacer les filtres
					</Box>
				</Stack>
				<Stack direction="row" sx={classes.filters}>
					<Box sx={classes.filterItem}>
						<FormControl sx={classes.select}>
							<Select
								multiple
								variant='outlined'
								value={filterValues.category || []}
								displayEmpty
								onChange={
									(e) => {
										const value = e.target.value;
										setFilterValues({
											...filterValues,
											'category': typeof value === 'string' ? value.split(',') : value,
										})
									}
								}
								renderValue={(selected) => {
									if(!selected.length) {
										return <span style={{ color: 'gray' }}>Catégories</span>
									}

									return eventCategories
										.filter((item) => selected.includes(item.value))
										.map((item) => item.label).join(', ');
								}}
								style={{
									color: filterValues.category === '' && 'gray',
									'&:hover': { display: 'none'	}
								}}
							>
								{eventCategories.map(({ value, label }) => (
									<MenuItem	key={value} value={value}>
										<Checkbox checked={filterValues.category?.includes(value)} />
										{label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>
					<Box sx={classes.filterItem}>
						<FormControl sx={classes.select}>
							<Select
								multiple
								variant='outlined'
								value={filterValues.location || []}
								displayEmpty
								onChange={
									(e) => {
										const value = e.target.value;
										setFilterValues({
											...filterValues,
											'location': typeof value === 'string' ? value.split(',') : value,
										})
									}
								}
								renderValue={(selected) => {
									if(!selected.length) {
										return <span style={{ color: 'gray' }}>Localisation</span>
									}

									return locations
										.filter((item) => selected.includes(item.value))
										.map((item) => item.label).join(', ');
								}}
								style={{
									color: filterValues.location === '' && 'gray',
									'&:hover': { display: 'none'	}
								}}
								sx={{ fontSize: '12px' }}
							>
								{locations.map(({ value, label }) => (
									<MenuItem	key={value} value={value}>
										<Checkbox checked={filterValues.location?.includes(value)} />
										{label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>
					<Box sx={classes.filterItem}>
						<FormControl sx={classes.select}>
							<Select
								variant='outlined'
								onChange={
									(e) => setFilterValues({ ...filterValues, 'type': e.target.value })
								}
								value={filterValues.type || 'Type'}
								displayEmpty
								renderValue={(selected) => selected || null}
								style={{
									color: filterValues.type === '' && 'gray',
									'&:hover': { display: 'none'	}
								}}
							>
								{eventTypeOptions.map(({ value, label }) => (
									<MenuItem	key={value} value={value}>
										{label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>
					<Box sx={classes.filterButton}>
						<Button
							variant="contained"
							color="primary"
							sx={classes.button}
							onClick={() => {
								searchEvents();
							}}
						>
							Rechercher
						</Button>
					</Box>
				</Stack>
			</Box>
		)
	}

	let mobileFilters = () => {
		return(
			<>
				<Box sx={classes.header}>
					<Stack direction="column" justifyContent="center" spacing={1}>
						<Stack direction="row" justifyContent="space-between" spacing={1}>
							<Typography sx={classes.title}>Evénements à venir</Typography>
							<Box sx={classes.clearFilters} onClick={() => clearFilters()}>
								Effacer les filtres
							</Box>
						</Stack>
						<Box sx={classes.filterItem}>
							<FormControl sx={classes.select}>
								<Select
									multiple
									variant='outlined'
									value={filterValues.category || []}
									displayEmpty
									onChange={
										(e) => {
											const value = e.target.value;
											setFilterValues({
												...filterValues,
												'category': typeof value === 'string' ? value.split(',') : value,
											})
										}
									}
									renderValue={(selected) => {
										if(!selected.length) {
											return <span style={{ color: 'gray' }}>Catégories</span>
										}

										return eventCategories
											.filter((item) => selected.includes(item.value))
											.map((item) => item.label).join(', ');
									}}
									style={{
										color: filterValues.category === '' && 'gray',
										'&:hover': { display: 'none'	}
									}}
								>
									{eventCategories.map(({ value, label }) => (
										<MenuItem	key={value} value={value}>
											<Checkbox checked={filterValues.category?.includes(value)} />
											{label}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Box>
						<Box sx={classes.filterItem}>
							<FormControl sx={classes.select}>
								<Select
									multiple
									variant='outlined'
									value={filterValues.location || []}
									displayEmpty
									onChange={
										(e) => {
											const value = e.target.value;
											setFilterValues({
												...filterValues,
												'location': typeof value === 'string' ? value.split(',') : value,
											})
										}
									}
									renderValue={(selected) => {
										if(!selected.length) {
											return <span style={{ color: 'gray' }}>Localisation</span>
										}

										return locations
											.filter((item) => selected.includes(item.value))
											.map((item) => item.label).join(', ');
									}}
									style={{
										color: filterValues.location === '' && 'gray',
										'&:hover': { display: 'none'	}
									}}
									sx={{ fontSize: '12px' }}
								>
									{locations.map(({ value, label }) => (
										<MenuItem	key={value} value={value}>
											<Checkbox checked={filterValues.location?.includes(value)} />
											{label}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Box>
						<Box sx={classes.filterItem}>
							<FormControl sx={classes.select}>
								<Select
									variant='outlined'
									onChange={
										(e) => setFilterValues({ ...filterValues, 'type': e.target.value })
									}
									value={filterValues.type || 'Type'}
									displayEmpty
									renderValue={(selected) => selected || null}
									style={{
										color: filterValues.type === '' && 'gray',
										'&:hover': { display: 'none'	}
									}}
								>
									{eventTypeOptions.map(({ value, label }) => (
										<MenuItem	key={value} value={value}>
											{label}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Box>
						<Box sx={classes.filterButton}>
							<Button
								variant="contained"
								color="primary"
								sx={classes.button}
								onClick={() => {
									searchEvents();
								}}
							>
								Rechercher
							</Button>
						</Box>
					</Stack>
				</Box>
			</>
		)
	}

	return(
		<Box sx={{
			minHeight: '100dvh',
			display: 'flex',
			flexDirection: 'column',
		}}>
			<Box sx={{ flex: 1 }}>
				{futureEvents?.length > 0 && (
					<Carousel
						events={futureEvents}
					/>
				)}
				<Card sx={classes.eventsCard}>
					{isMobile ? mobileFilters() : cardEventsListHeader() }
					<CardContent style={{ padding: '24px 26px' }}>
						<Paper sx={{ boxShadow: 'unset', paddingBottom: '12px' }}>
							<Tabs
									value={tabValue}
									onChange={handleChangeTab}
									indicatorColor="white"
									textColor="primary"
									scrollButtons='auto'
									sx={classes.tabs}
								>
									<Tab label="Evénements à Venir" sx={classes.tabStyles} />
									<Tab label="Tous" sx={classes.tabStyles} />
									<Tab label="Evénements Passés" sx={classes.tabStyles} />
									<Tab label="Evénements en Direct" sx={classes.tabStyles} />
							</Tabs>
						</Paper>
						<Box sx={classes.cardsContainer}>
							{events.map((item, key) => {
								const {
									attributes: { website, event_uri},
									id,
								} = item;
								return (
								<CardActionArea
									key={id || key}
									component="a"
									href={website ? website : `https://live.eventtia.com/en/${event_uri}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									<EventCard event={item}/>
							</CardActionArea>
							)})}
						</Box>
						{totalPages > 1 && (
							<Box sx={classes.pagination}>
								<Pagination
									page={page} 
									count={Math.ceil(totalEvents / 2)}
									onChange={handlePageChange}
								/>
							</Box>
						)}
					</CardContent>
				</Card>
			</Box>
			<Footer />
		</Box>
	)
}

export default (Home);